// Persistent topbar shared by every main-content destination (word detail,
// bulk add, settings). The left side always carries the word-history back/forward
// nav; on mobile the word detail additionally shows a back-to-list chevron.
// Page-specific actions (e.g. the word editor's quick-add / save / mode toggle)
// are passed as children into the right-hand action area.
import { TopbarNav } from '@/components/words/topbar-nav';
import { useWordsNav } from '@/lib/words-nav';
import type { ReactNode } from 'react';

interface WordShellTopbarProps {
  /** Show the mobile-only "back to list" chevron (word detail only). */
  showListBack?: boolean;
  /** Right-aligned, page-specific actions. */
  children?: ReactNode;
}

/** Shell topbar: word back/forward nav + optional list-back chevron + page actions. */
export function WordShellTopbar({ showListBack = false, children }: WordShellTopbarProps) {
  const nav = useWordsNav();

  return (
    <div className="words-topbar">
      <div className="words-topbar__lead">
        {showListBack && (
          <button
            type="button"
            className="words-nav-btn words-topbar__list-back"
            aria-label="Retour à la liste"
            onClick={nav.goToList}
          >
            <span className="material-symbols-rounded" aria-hidden="true">
              arrow_back_ios_new
            </span>
          </button>
        )}
        <TopbarNav />
      </div>
      {children && <div className="words-topbar__actions">{children}</div>}
    </div>
  );
}
